import React from "react";
import { Box, BoxProps, CircularProgress, CircularProgressProps } from "@mui/material";

interface Props {
  isLoading?: boolean;
  children: React.ReactNode;
  boxProps?: BoxProps;
  spinnerProps?: CircularProgressProps;
  overlay?: boolean;
}

const defaultBoxSx: BoxProps["sx"] = {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexGrow: 1
};

export const AsyncContentMui: React.FC<Props> = ({ isLoading, children, boxProps, spinnerProps, overlay }) => {
  const { sx: sxBox, ...restBoxProps } = boxProps || {};

  if (overlay) {
    return (
      <Box sx={{ ...defaultBoxSx, position: "relative", ...sxBox }} {...restBoxProps}>
        {isLoading && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              zIndex: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(247, 249, 252, 0.6)",
              pointerEvents: "none",
              overflow: "hidden"
            }}
          >
            <CircularProgress {...spinnerProps} />
          </Box>
        )}
        {children}
      </Box>
    );
  }

  if (isLoading) {
    return (
      <Box sx={{ ...defaultBoxSx, ...sxBox }} {...restBoxProps}>
        <CircularProgress {...spinnerProps} />
      </Box>
    );
  }
  return children;
};
